import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useMap } from 'react-map-gl';

import { getObstacles } from 'handimap-react-lib/api/obstacleApi';
import { setObstaclesList } from 'handimap-react-lib/store/actions/obstacleActions';
import { config } from 'handimap-react-lib/config';

export const ObstaclesEngine = () => {

  const dispatch = useDispatch();

  const { mymap } = useMap();

  const obstaclePicto = `${config.url.PUBLIC_URL}/layerIcons/bulle_warning_obstacles.png`;

  const showLayerObstacles = useSelector(state => state.obstacle.showLayer);

  const { 
    statusGetObstacles,
    obstaclesFeatures
  } = getObstacles();

  useEffect(() => {
    if (statusGetObstacles === 'success' && obstaclesFeatures) {
      dispatch(setObstaclesList(obstaclesFeatures));
    }
  }, [statusGetObstacles]);


  useEffect(() => {
    if (mymap) {
      if (!mymap.hasImage('obstacles')) {
        mymap.loadImage(obstaclePicto, (error, image) => {
          if (error) {
            throw(error);
          }
          mymap.addImage('obstacles', image, { sdf: false });
        });
      } else {
        console.log('mymap has image');
      }
    }
  }, [mymap]);

  useEffect(() => {
    if (mymap) {
      if (obstaclesFeatures && !mymap.getMap().getSource('obstacles-sources')) {
        mymap.getMap().addSource('obstacles-sources', {
          type: 'geojson',
          data: obstaclesFeatures
        });
        mymap.getMap().addLayer({
          id: 'obstacles-layer',
          type: 'symbol',
          source: 'obstacles-sources',
          layout: {
            'icon-image': 'obstacles',
            'icon-size': [
              'interpolate',
              ['linear'],
              ['zoom'],
              10, 0.3,   
              15, 0.5   
            ],
            'icon-allow-overlap': false
          },
          paint: {
            'icon-opacity': 1, // Set to 1 for full visibility
          }
        });
      }
    }
  }, [obstaclesFeatures]);

  useEffect(() => {
    if (mymap) {
      mymap.getMap().setLayoutProperty('obstacles-layer', 'visibility', showLayerObstacles ? 'visible' : 'none');
    }
  }, [showLayerObstacles]);

  return null;
};